module.exports = __webpack_public_path__ + "img/logo6.9958fa8d.png";